package com.example.readingnotes.platform

import kotlinx.browser.window

public actual object BrowserOpener {
    public actual suspend fun openUrl(url: String): Boolean =
        try {
            window.open(url, "_blank")
            true
        } catch (e: Throwable) {
            console.error("Failed to open URL:", e)
            false
        }
}
